import { v4 as uuidV4 } from 'uuid';

export class RequestError extends Error {
  status: number | undefined;
  response: object | string | undefined;
}

export class NotFoundError extends RequestError {}

const HTTP_NO_CONTENT = 204;
const HTTP_NOT_FOUND = 404;

export const buildRequestError = ({
  status,
  errors
}: {
  status: number;
  errors: object | string;
}) => {
  let error;

  if (status === HTTP_NOT_FOUND) {
    error = new NotFoundError('An error occurred while fetching the data.');
  } else {
    error = new RequestError('An error occurred while fetching the data.');
  }

  error.status = status;
  error.response = errors;
  return error;
};

export const jsonFetcher = async (
  url: string | URL | Request,
  options: RequestInit & { noResponse?: boolean }
) => {
  const res = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      'X-Request-Id': uuidV4(),
      ...(options?.headers || {})
    }
  });

  if (!res.ok) {
    const errors = await res.json();
    throw buildRequestError({ status: res.status, errors });
  }

  if (options?.noResponse || res.status === HTTP_NO_CONTENT) {
    return {};
  }

  return await res.json();
};

export const textFetcher = async (url: string | URL | Request, options: RequestInit) => {
  const res = await fetch(url, {
    headers: { 'X-Request-Id': uuidV4(), ...(options?.headers || {}) },
    ...options
  });

  if (!res.ok) {
    const errors = await res.text();
    throw buildRequestError({ status: res.status, errors });
  }

  return await res.text();
};

export const binaryFetcher = async (url: string | URL | Request, options: RequestInit) => {
  const res = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      'X-Request-Id': uuidV4(),
      ...(options?.headers || {})
    }
  });

  if (!res.ok) {
    const errors = await res.text();
    throw buildRequestError({ status: res.status, errors });
  }

  return await res.blob();
};
